function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 1a7 7 0 11-.001 14.001A7 7 0 018 1zm0 9.371a.79.79 0 100 1.58.79.79 0 000-1.58zm-.01-6.323c-1.265 0-1.975.495-2.575 1.263a.338.338 0 00.075.485l.37.258a.34.34 0 00.46-.067c.421-.537.848-.81 1.67-.81 1.12 0 1.622.57 1.622 1.135 0 1.236-2.186 1.047-2.186 3.032v.01c0 .188.152.34.339.34h.451a.34.34 0 00.34-.34v-.01c0-1.23 2.185-1.129 2.185-3.032 0-1.424-1.274-2.264-2.75-2.264z",
  fill: "#adc6ca",
  fillRule: "nonzero"
});

function SvgNotificationQuestioninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgNotificationQuestioninline;